import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2 } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Profile = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Priya Sharma',
        email: 'priya.sharma@example.com',
        phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Priya+Sharma&size=200&background=1B4965&color=fff',
        address: {
            street: '42 Marina Bay',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400001',
        },
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData({
                ...profileData,
                [parent]: { ...profileData[parent], [child]: value },
            });
        } else {
            setProfileData({ ...profileData, [name]: value });
        }
    };

    const handleSave = () => {
        setIsEditing(false);
        devLog('Profile saved:', profileData);
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'wishlist', label: 'Wishlist', icon: Heart },
    ];

    const inputClass = "w-full px-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A] bg-white";

    return (
        <div className="w-full min-h-screen bg-[#F0F7FA]" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24 pb-16">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl md:text-3xl font-semibold text-[#1B4965] mb-8 pt-4">My Account</h1>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        {/* Sidebar */}
                        <div className="md:col-span-1">
                            <div className="bg-white border border-[#E5E7EB] rounded-sm p-4">
                                {/* Avatar */}
                                <div className="text-center mb-4">
                                    <div className="relative inline-block">
                                        <img
                                            src={profileData.avatar}
                                            alt={profileData.fullName}
                                            className="w-20 h-20 rounded-full object-cover border-2 border-[#1B4965]"
                                        />
                                        <button className="absolute bottom-0 right-0 w-7 h-7 bg-[#1B4965] rounded-full flex items-center justify-center text-white">
                                            <Camera className="w-3.5 h-3.5" />
                                        </button>
                                    </div>
                                    <p className="text-sm font-semibold text-[#1A1A1A] mt-2">{profileData.fullName}</p>
                                    <p className="text-xs text-[#6B7280]">{profileData.email}</p>
                                </div>

                                {/* Tabs */}
                                <nav className="space-y-1">
                                    {tabs.map((tab) => {
                                        const Icon = tab.icon;
                                        return (
                                            <button
                                                key={tab.id}
                                                onClick={() => tab.id === 'orders' ? navigate('/template4/orders') : setActiveTab(tab.id)}
                                                className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm rounded-sm transition-all ${
                                                    activeTab === tab.id
                                                        ? 'bg-[#F0F7FA] text-[#1B4965] font-medium'
                                                        : 'text-[#6B7280] hover:bg-[#F0F7FA]'
                                                }`}
                                            >
                                                <Icon className="w-4 h-4" />
                                                {tab.label}
                                            </button>
                                        );
                                    })}
                                    <button className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-red-500 hover:bg-red-50 rounded-sm transition-all">
                                        <LogOut className="w-4 h-4" />
                                        Sign Out
                                    </button>
                                </nav>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="md:col-span-3">
                            <div className="bg-white border border-[#E5E7EB] rounded-sm p-6">
                                {activeTab === 'profile' && (
                                    <div>
                                        <div className="flex items-center justify-between mb-6">
                                            <h2 className="text-lg font-semibold text-[#1B4965]">Personal Information</h2>
                                            <button
                                                onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                                                className="flex items-center gap-2 text-sm font-medium text-[#1B4965] hover:text-[#133B53] bg-transparent border-none cursor-pointer"
                                            >
                                                {isEditing ? <><Save className="w-4 h-4" /> Save</> : <><Edit2 className="w-4 h-4" /> Edit</>}
                                            </button>
                                        </div>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Full Name</label>
                                                <input name="fullName" value={profileData.fullName} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Email</label>
                                                <input name="email" value={profileData.email} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Phone</label>
                                                <input name="phone" value={profileData.phone} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                        </div>

                                        <h3 className="text-sm font-semibold text-[#1B4965] mt-8 mb-4">Address</h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div className="sm:col-span-2">
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Street</label>
                                                <input name="address.street" value={profileData.address.street} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">City</label>
                                                <input name="address.city" value={profileData.address.city} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">State</label>
                                                <input name="address.state" value={profileData.address.state} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Pincode</label>
                                                <input name="address.pincode" value={profileData.address.pincode} onChange={handleInputChange} disabled={!isEditing} className={`${inputClass} ${!isEditing ? 'bg-[#F0F7FA]' : ''}`} />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'wishlist' && (
                                    <div>
                                        <h2 className="text-lg font-semibold text-[#1B4965] mb-6">My Wishlist</h2>
                                        <div className="text-center py-12">
                                            <Heart className="w-12 h-12 text-[#6B7280] mx-auto mb-4" />
                                            <p className="text-sm text-[#6B7280] mb-4">Your wishlist is empty</p>
                                            <Button variant="primary" onClick={() => navigate('/template4/shop')}>
                                                Browse Collections
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Profile;
